import React, { FC, useCallback, useState, useEffect, memo } from 'react'
import { useController } from 'react-hook-form'
import { InputGroup, Select } from '@wmgtech/legato'
import { useMediaBuyer } from 'modules/MediaBuyer/services'
import { IFieldError, validationAdapter } from 'components/Fields'
import { IAdvertiser, IMediaBuyer } from 'modules/Admin'

export const FormMediaBuyerSelect: FC = memo(() => {
  const NAME = 'mediaBuyer'
  const { field: { onChange, ref, ...rest }, formState: { errors } } = useController({ name: NAME })
  const [options, setOptions] = useState<IMediaBuyer[]>([]);
  const { mediaBuyers } = useMediaBuyer()

  const handleChange = useCallback((adv: IMediaBuyer) => {
    if (adv) {
      onChange(adv.id)
    }
  }, [onChange])

  const onSearch = useCallback((list: IMediaBuyer[], term: string): IMediaBuyer[] =>
    term && mediaBuyers ?
      mediaBuyers.filter((opt: IMediaBuyer) => opt.name.toLowerCase().includes(term.toLowerCase())) :
      mediaBuyers ?? [], [mediaBuyers])

  const validation = useCallback((error?: IFieldError) => ({
    required: true,
    ...validationAdapter(error),
  }),[])

  useEffect(() => {
    mediaBuyers && setOptions(mediaBuyers);
  }, [mediaBuyers])

  return (
    <InputGroup label="Media Buyer" validation={validation(errors[NAME] as IFieldError)}>
      <Select<IAdvertiser>
        onSelect={handleChange}
        placeholder="Select Media Buyer"
        list={options}
        getKey={(el) => el.id}
        getTitle={(el) => el.name}
        isFilterable
        onFilter={onSearch}
        searchInputPlaceholder="Type Media Buyer"
        {...rest}
      />
    </InputGroup>
  )
})
